export enum ClipboardScoreActions {
  WORK_SHIFT = "WORK_SHIFT",
  CANCEL_SHIFT = "CANCEL_SHIFT",
  NO_CALL_NO_SHOW = "NO_CALL_NO_SHOW",
  CORRECT_SCORE = "CORRECT_SCORE",
  ACCOUNT_RE_ENROLL = "ACCOUNT_RE_ENROLL",
  START_SHIFT_LATE = "START_SHIFT_LATE",
  CLOCKIN_TIMELINESS_BONUS = "CLOCKIN_TIMELINESS_BONUS",
  QUALITY_BONUS = "QUALITY_BONUS",
  CLIPBOARD_SCORE_LAUNCH = "CLIPBOARD_SCORE_LAUNCH",
  WORKER_LEFT_EARLY_WITHOUT_PERMISSION = "WORKER_LEFT_EARLY_WITHOUT_PERMISSION",
  ORIENTATION_PASSED = "ORIENTATION_PASSED",
  ORIENTATION_ACTIVATION = "ORIENTATION_ACTIVATION",
  ORIENTATION_DEACTIVATION = "ORIENTATION_DEACTIVATION",
  CUSTOM_BONUS = "CUSTOM_BONUS",
}

export const clipboardScoreActionLabelMap: Record<ClipboardScoreActions, string> = {
  WORK_SHIFT: "Worked Shift",
  CANCEL_SHIFT: "Cancellation",
  NO_CALL_NO_SHOW: "No Show",
  CORRECT_SCORE: "Score Correction",
  ACCOUNT_RE_ENROLL: "Account Re-enrolled",
  START_SHIFT_LATE: "Shift Started Late",
  CLOCKIN_TIMELINESS_BONUS: "Arrived on time",
  QUALITY_BONUS: "Excellence Bonus",
  CLIPBOARD_SCORE_LAUNCH: "Clipboard Score Launch",
  WORKER_LEFT_EARLY_WITHOUT_PERMISSION: "Shift Abandonment",
  ORIENTATION_PASSED: "Demo shift completed",
  ORIENTATION_ACTIVATION: "Demo shift activated",
  ORIENTATION_DEACTIVATION: "Demo shift deactivated",
  CUSTOM_BONUS: "Custom Bonus",
};

export const reasonDisplayMap: Record<string, Record<string, string>> = {
  [ClipboardScoreActions.START_SHIFT_LATE]: {
    SECOND_IN_DOUBLE:
      "You didn't lose points for this penalty because the shift was a second in a double.",
    SHORT_LEAD_TIME_BOOKING:
      "You didn't lose points for this penalty because the shift was picked up within 4 hours of the start time.",
    GRACE_PERIOD:
      "You missed out on the timeliness bonus. Plan ahead for traffic and aim to arrive early to lock it in next shift.",
  },
  [ClipboardScoreActions.CLOCKIN_TIMELINESS_BONUS]: {
    SECOND_IN_DOUBLE:
      "You didn't earn bonus points for arriving on time because this shift was the second in a double.",
  },
};
